'use client';

import { ReactNode, useState } from 'react';
import { trackTabClicked } from 'src/analytics/Events';
import { Vertical } from 'src/constants/Verticals';
import ToggleItem, { ToggleItemProps } from '../ToggleItem/ToggleItem';
import styles from './toggle-group.module.scss';

type ToggleGroupProps = {
    buttons: Omit<ToggleItemProps, 'id' | 'onClick'>[];
    panels: Panel[];
    className?: string;
    initActiveItemId?: number;
    onClick?: (id: number) => void;
    vertical?: Vertical;
};

export type Panel = {
    content: ReactNode;
};

const ToggleGroup = ({
    buttons,
    panels,
    initActiveItemId,
    onClick,
    className,
    vertical,
}: ToggleGroupProps) => {
    const [activeId, setActiveId] = useState(initActiveItemId || 0);

    const handleClick = (id: number, tabLabel: string) => {
        setActiveId(id);
        trackTabClicked(tabLabel, vertical);
    };

    return (
        <>
            {buttons?.length > 0 ? (
                <div className={className} data-toggle-group>
                    {buttons?.map((button, i) => (
                        <ToggleItem
                            key={i}
                            id={i}
                            label={button.label}
                            img={button.img}
                            imgWidth={button.imgWidth}
                            imgHeight={button.imgHeight}
                            onClick={() => {
                                handleClick(i, button.label);
                                if (onClick) onClick(i);
                            }}
                            isActive={i === activeId}
                        />
                    ))}
                </div>
            ) : null}
            {panels?.map((panel, i) => (
                <div
                    key={i}
                    className={
                        i === activeId
                            ? styles['toggle-group__panel--active']
                            : styles['toggle-group__panel--hidden']
                    }
                    data-toggle-panel-active={i === activeId}
                >
                    {panel.content}
                </div>
            ))}
        </>
    );
};

export default ToggleGroup;
